/**
 * SAV : statistiques des tickets (mêmes règles que les autres sections), et
 * messages Gorgias lus en direct, page par page.
 *
 * Les messages ne sont gardés en mémoire que le temps de l'affichage : pas de
 * persistance du cache React Query, et `gcTime` court.
 */

import type { SavStats } from '@shared/types/sav';
import { useInfiniteQuery } from '@tanstack/react-query';

import { ApiRequestError, fetchSavMessages, fetchSavStats } from '../lib/api';
import { useSectionStats, type SectionStatsOptions } from './useSectionStats';

export function useSavStats(options: SectionStatsOptions) {
  return useSectionStats<SavStats>('sav-stats', fetchSavStats, options);
}

export function useSavMessages(token: string | null, onUnauthorized?: () => void) {
  return useInfiniteQuery({
    queryKey: ['sav-messages'],
    queryFn: async ({ pageParam, signal }) => {
      if (!token) throw new ApiRequestError(401, 'Session expiree');
      try {
        return await fetchSavMessages(pageParam, token, signal);
      } catch (error) {
        if (error instanceof ApiRequestError && error.status === 401) onUnauthorized?.();
        throw error;
      }
    },
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage) => lastPage.nextCursor,
    enabled: Boolean(token),
    staleTime: 60_000,
    gcTime: 60_000,
    retry: false,
  });
}
